/* Prevents layout shift caused by scrollbar appearing/disappearing.
   scrollbar-gutter: stable reserves the scrollbar space permanently,
   keeping the page width consistent regardless of content height. */
html {
  scrollbar-gutter: stable;
}
